import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import type { ZendeskWorkspaceT } from '@/features/Setting/Integrations/providers/types';
import useCrossWindowState from '@/hooks/domain/useCrossWindowState';
import LoadingLayout from '@/layouts/LoadingLayout';
import services from '@/services/index';
const ZendeskRedirect = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [, setRedirect] = useCrossWindowState<ZendeskWorkspaceT | null>(
    'zendesk-redirect',
    null,
  );

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (code && state) {
      const data = sessionStorage.getItem(state);
      if (!data) return;
      const { workspaceAlias, subdomain } = JSON.parse(data);

      const asyncUpdateHandler = async () => {
        const data = await services.zendesk.createZendeskInfo(
          code,
          workspaceAlias,
          `${window.location.origin}/zendesk`,
          subdomain,
        );
        if (data) {
          setRedirect(data);
          window.close();
        } else {
          navigate('/500', { replace: true });
        }
      };
      asyncUpdateHandler();
    }
  }, [setRedirect, searchParams, navigate]);

  return <LoadingLayout>Connecting zendesk...</LoadingLayout>;
};

export default ZendeskRedirect;
